export const urlOrRelativeRegexp = /^((https?):\/\/[^\s$.?#].[^\s]*|\/[^\s]*)$/i
